import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { useIsMobile } from '@sravni/react-utils';

import { useDictionaries } from 'entities/creditForm';

import styles from './Period.module.scss';

export const Period: FC<IFieldFactoryProps> = ({ type, ...props }) => {
  const isMobile = useIsMobile();

  const { periods } = useDictionaries(['periods']);

  return (
    <ControlledCustomSelect
      {...props}
      name={type}
      options={periods}
      withCrossIcon={false}
      mobile={isMobile}
      menuClassName={styles.mobileDropdown}
    />
  );
};
